module.exports = __webpack_public_path__ + "assets/images/intro-bg-2_8dabb2adbdbb85002395bc882233bd11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro/intro-bg-2.png
// module id = 128
// module chunks = 0